module.exports = __webpack_public_path__ + "static/img/jt3.5563340.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/jt3.jpg
// module id = rKhl
// module chunks = 1